<template>
  <div class="pm200">
    <img src="../assets/img/banner.jpg" class="banner w100 cz" />
    <div>
      <div class="kjnjsfoer pd pt20">
        <p class="fz16 z3">参观日期</p>
        <div class="row">
          <div
            class="kjmmjknmxer cen mr15"
            v-for="(date, idx) in options.dates"
            :key="date.date"
            :class="{
              act: orderInput.travelDate === date.date,
              disabled: date.disable,
            }"
            @click="dateChanged(idx)"
          >
            <p class="fz12 z3 dfgdt">{{ date.text.substr(0, 2) }}</p>
            <div class="cen btm zts fz16 pt10" style="font-size: 14px">
              {{ date.disable ? "不可订" : date.text.substr(2) }}
            </div>
          </div>
          <div class="col">
            <div class="kjmmjknmxer cen mr15 w100" @click="selectMoreDate">
              <p class="fz12 z3 dfgdt">更多</p>
              <div class="cen btm zts fz16 pt5">
                <i class="f_i gengdder"></i>
              </div>
            </div>
          </div>
        </div>
        <p class="mt15 fz16">
          参观区域
          <!-- <span class="z9 fz12"> (选择参观区域再选择入馆时段)</span> -->
        </p>
        <van-grid
          v-if="grounds[0]"
          :border="false"
          :column-num="2"
          style="margin-right: -10px"
        >
          <van-grid-item
            v-for="ground in grounds[0].children"
            :key="ground.value"
            :name="ground.value"
          >
            <div
              class="row fgdrtwer"
              :class="[
                ground.disabled || wxLastBookTime ? 'acb' : '',
                orderInput.groundId == ground.value ? 'act' : '',
              ]"
              @click="groundChange(ground)"
            >
              <div class="kmmxeert">
                <i class="f_i gounmxer" v-if="!ground.disabled"></i>
                <div v-else class="kjnmkxerse">闭<br />馆</div>
              </div>
              <div class="col pl5 pr5 z3 fz14 kmmxeert2">
                {{ ground.displayText }}
              </div>
            </div>
          </van-grid-item>
        </van-grid>
        <van-row>
          <div v-if="wxLastBookTime" class="panel-content">
            <div class="content-text2">
              超过今天最晚预约时间 {{ wxLastBookTime }}
            </div>
          </div>
        </van-row>
        <div class="mt10">
          <p class="fz16 pm10">公益讲解场次</p>
          <!-- <van-cell-group class>
            <van-cell title="需要讲解" class="field-cell left">
              <div class="explain">
                <van-switch
                  v-model="orderInput.needExplain"
                  size="18px"
                  class="group-order-switch"
                  active-color="#845F56"
                />
              </div>
            </van-cell>
          </van-cell-group> -->

          <div class="" v-if="explainers && explainers.length > 0">
            <div v-for="(explainer, idx) in explainers" :key="idx">
              <div v-if="explainer.children.length > 0">
                <p class="fz12 z9 pt10">请选择{{ explainer.text }}讲解时间</p>
                <van-grid
                  :border="false"
                  :column-num="2"
                >
                  <van-grid-item
                    class="fgdrtwerab"
                    :class="[child.selected ? 'act' : '']"          
                    style="flex-basis: calc(50% - 10px); margin-left: 5px; margin-right: 5px;"
                    v-for="child in explainer.children"
                    :key="child.value"
                    @click="onSelectExplainerTimePoint(child, explainer.children)"
                  >
                    <div>
                      <p class="fz17" :class="[child.disabled ? 'z9' : 'z6']">
                        <!-- {{ child.text.substr(0, 11) }} -->
                        {{ child.name }} 
                      </p>
                      <!-- <p class="zts fz12">{{child.text.substr(11)}}</p> -->
                      <p class="fz12" :class="[child.disabled ? 'z9' : 'zts']">
                        ({{ changCiText(child) }})
                      </p>
                    </div>
                  </van-grid-item>
                </van-grid>
              </div>
            </div>
          </div>
          <div class="" v-else>          
            <p class="fz14" style="color:#a9716d; padding: 10px;">
              当前无公益讲解
            </p>
          </div>
          
        </div>
        <div class="mt10" v-if="selectExplainer">       
          <van-cell-group class>
            <date-field
              label="讲解时间"
              v-model="orderInput.arrivalTime"
              placeholder="必填，请选择讲解时间"
              type="time"
              :min-hour="minHour"
              :max-hour="maxHour"
              :minValue="minValue"
              :maxValue="maxValue"
              :showMsg="selectExplainer"
              
            />
          </van-cell-group>         
        </div>
        <div v-if="explainers && explainers.length > 0"> 
          <div class="fz12 red" style="padding: 10px 16px;">
            <p>须知：1、公益讲解预约（由于场地条件限制，需要{{ options.groupExplainMinQuantity }}人起约，最多{{ options.groupExplainMaxQuantity }}人）</p>
            <p>　　　2、预约成功后，请务必在预约的讲解时间前10分钟到达展厅讲解咨询处，核验预约凭证(二维码)，超过15分钟未到本次预约作废，敬请合理安排出行时间。</p>
          </div>
        </div>
      </div>
      <div class="mt10 pd">
        <p class="mt15 fz16 pm10">参观信息</p>
        <div style="height: 45px">
          <div
            class="cz"
            style="
              color: #646566;
              float: left;
              padding-left: 16px;
              padding-right: 12px;
              margin-top: 11px;
              font-size: 14px;
            "
          >
            预约单位
          </div>
          <el-autocomplete
            @focus="onQuerySearchFocus"
            class="inline-input querySearch"
            v-model="state1"
            :maxlength="50"
            :fetch-suggestions="querySearch"
            placeholder="必填，请输入预约单位"
            @select="handleSelect"
          ></el-autocomplete>
        </div>


        <van-cell-group>
          <van-field
            label="接待单位"
            :maxlength="50"
            placeholder="选填，请输入接待单位"
            v-model="orderInput.receivingCustomer"
            clearable
          ></van-field>
        </van-cell-group>
        <div
          class="row"
          style="margin-top: 6px; margin-bottom: 6px; margin-right: 20px"
        >
          <div
            class="cz col"
            style="
              color: #646566;
              margin-top: 3px;
              float: left;
              padding-left: 16px;
              padding-right: 12px;
              font-size: 14px;
            "
          >
            参观人数
          </div>
          <!-- <van-stepper
            v-model="personNum"
            :defaultValue="0"
            :min="0"
            :max="groupOrderMaxQuantity"
            integer
          /> -->
          <van-stepper
            async-change
            :value="personNum"
            :defaultValue="0"
            :min="groupOrderMinQuantity"
            max="300"
            @change="onAdultQuantityChange"            
            @blur="onAdultQuantityBlur"
            integer
            step="1"
            ref="stepper"
          />
        </div>
        <van-cell-group class>
          <van-field
            label="接待领导"
            :maxlength="30"
            placeholder="选填，请输入接待领导"
            v-model="orderInput.receptionLeader"
            clearable
          ></van-field>
        </van-cell-group>
        <van-cell-group class>
          <van-field
            label="陪同领导"
            :maxlength="30"
            placeholder="选填，请输入陪同领导"
            v-model="orderInput.accompanyLeader"
            clearable
          ></van-field>
        </van-cell-group>
        <van-cell-group class>
        </van-cell-group>        
        <van-cell-group class>
          <van-cell title="参观函(介绍信)" title-style="min-width:120px" center>
            <van-uploader
              v-model="fileList"
              preview-size="60"
              multiple
              max-count="1"
              :before-read="beforeRead"
              :after-read="afterRead"
            >
            </van-uploader>
          </van-cell>
        </van-cell-group>
        <div class="row pt15 pd dfghyuwrr">
          <span class="fz14" style="color: #646566">备注</span>
          <div class="pl col pl10">
            <input
              type="text"
              placeholder="请输入内容"
              class="sfgdywer"
              v-model="orderInput.memo"
            />
          </div>
        </div>
      </div>
      <div class="pd bgff pt15">
        <div v-if="packingLotId">
          <p class="mt20 fz16 pm10">停车位信息</p>
          <van-cell-group class>
            <van-cell title="需要停车位" class="field-cell left">
              <div class="explain">
                <van-switch
                  v-model="orderInput.needPackingLot"
                  size="18px"
                  class="group-order-switch"
                  active-color="#845F56"
                />
              </div>
            </van-cell>
          </van-cell-group>

          <div v-if="orderInput.needPackingLot && packingLotId">
            <div class="row">
              <p
                class="col mt10 mb10"
                style="padding-left: 16px; font-size: 14px; color: #646566"
              >
                车位数量
              </p>
              <van-stepper
                class="row mt5"
                async-change
                :value="licensePlateNumberQuantity"
                :defaultValue="1"
                :min="0"
                :max="maximumParkingSpacesForTeamBooking"
                @change="onLicensePlateNumberQuantity"
                integer
                disable-input
              />
            </div>
            <!-- <div class="tourist-tips">
              <van-icon name="info-o" />
              <span>
               小型车:余{{ carSpacingNum }}车位，  大客车:余{{ busSpacingNum }}车位
              </span>
            </div> -->
            <div class="sdfsdtywer">
              <van-cell-group
                v-for="(licensePlateNumber, index) in licensePlateNumbers"
                :key="index"
              >
                <div class="jjnnjxer ml10 fz14 adult-index">
                  {{ index + 1 }}
                </div>
                <div>
                  <van-cell
                    class="pl30"
                    title="车辆类型"
                    :value="licensePlateNumber.carTypeName || '请选择'"
                    :value-class="licensePlateNumber.carTypeId ? 'z3' : ''"
                    is-link
                    @click="onShowCarType(index)"
                  />
                  <!-- <van-field
                    class="pl30"
                    maxlength="8" 
                    placeholder="必填，请输入车牌号码"
                    v-model="licensePlateNumber.licensePlateNumber"
                    @blur="cphInputClick(index)"
                    clearable
                  >
                    <template slot="label">
                      <span class="cz">车牌号码</span>
                    </template>
                  </van-field>   -->
                  <van-field
                    readonly
                    class="pl30"
                    maxlength="8" 
                    placeholder="必填，请输入车牌号码"
                    :value="licensePlateNumber.licensePlateNumber"
                    @click="cphClick(index)"
                  >
                    <template slot="label">
                      <span class="cz">车牌号码</span>
                    </template>
                  </van-field>
                </div>
              </van-cell-group>
            </div>
          </div>
        </div>
       
        <p class="mt15 fz16 pm10">联系人信息</p>
        <van-cell-group>
          <van-field
            label="姓名"
            :maxlength="30"
            placeholder="必填，请输入联系人姓名"
            v-model="orderInput.contactName"
            clearable
          ></van-field>
          <van-field
            label="手机号码"
            :maxlength="11"
            placeholder="必填，请输入联系人手机号码"
            type="tel"
            v-model="orderInput.contactMobile"
            clearable
          ></van-field>
        </van-cell-group>
        <!-- <div class="mt20 dsfsdtywwer btm">
          <van-button type="primary" class="w100" :loading="loading" @click="onSubmit">立即预约</van-button>
        </div> -->

        <bottom-button
          text="立即预约"
          :loading="loading"
          @click="onSubmit"
        ></bottom-button>
      </div>
    </div>

    <van-calendar
      v-model="showDateTimePicker"
      @confirm="confirmMoreDate"
      color="#A9716D"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <van-action-sheet
      v-model="showCarType"
      :actions="carTypes"
      @select="onCarTypeSelecter"
    />
      <car-key-board v-model="showkeyboard" :plateNumber="cph" :idx="clickIndex" @confirmBtnFn="confirmBtnFn"/>
  </div>
</template>

<script>
import DateSelector from "@/components/DateSelector.vue";
import DateField from "@/components/DateField.vue";
import BottomButton from "@/components/BottomButton.vue";
import PickerField from "@/components/PickerField.vue";
import CarKeyBoard from "@/components/CarKeyBoard.vue";
import moment from "moment";
import validate from "@/utils/validator.js";
import dateHelper from "@/utils/dateHelper.js";
import orderService from "@/services/orderService.js";
// import { mapState } from "vuex";
import explainerService from "@/services/explainerService.js";
import commonService from "@/services/commonService.js";
import scenicService from "./../services/scenicService.js";
import customerService from "@/services/customerService.js";

let defaultMinHour = 8;
let defaultArrivalTime = "";
function LicensePlateNumber() {
  this.licensePlateNumber = "";
  this.carTypeId = ""; //大客车
}
export default {
  components: {
    DateSelector,
    DateField,
    BottomButton,
    PickerField,
    CarKeyBoard,
  },
  data() {
    return {
      cph: new Array(8),
      showkeyboard: false,
      clickIndex: 0,
      loading: false,
      loadingExplainer: false,
      minValue: "",
      maxValue: "",
      minHour: defaultMinHour,
      maxHour: 18,
      orderInput: {
        travelDate: "",
        personNum: 0,
        arrivalTime: defaultArrivalTime,
        needPackingLot: false,
        plateNumbers: [],
        carTypeId: "",
        //licensePlateNumber: "",
        needExplain: true,
        explainerTimeslotSchedulings: [],
        contactName: "",
        contactMobile: "",
        keYuanTypeId: 1,
        areaId: "",
        jidiaoName: "",
        memo: "",
        groundId: "",
        changCiId: "",
        receivingCustomer: "",
        receptionLeader: "",
        accompanyLeader: "",
      },
      licensePlateNumberQuantity: 1,
      licensePlateNumbers: [{ licensePlateNumber: "", carTypeId: "" }],
      ageRanges: [],
      explainers: [],
      keYuanTypes: [],
      areaItems: [],
      regions: [],
      regionId: "",
      areas: [],
      options: {
        dates: [],
        maxBookDays: 30,
      },
      grounds: [],
      changCis: [],
      wxLastBookTime: "",
      showDateTimePicker: false,
      carSpacingNum: 0,
      busSpacingNum: 0,

      carTypes: [],
      showCarTypeIndex: 0,
      showCarType: false,
      carTypeName: "",
      packingLotId: "",

      customers: [],

      restaurants: [],
      state1: "",

      visitLetterPhotoArray: [],
      fileList: [],
      personNum: 0,
      changing: false, // 防重入锁
      fixing: false, // 修正stepper输入时的状态同步问题锁
    };
  },
  computed: {
    selectExplainer() {
      let result = false;
      if (this.explainers.length > 0) {
        this.explainers.forEach((element) => {
          element.children.forEach((child) => {
            if (child.selected) {
              result = true;
            }
          });
        });
      }
      return result;
    },
    groupOrderMaxQuantity() {
      let maxQuantity = 300;
      // if (this.options.groupOrderMaxQuantity > 0) {
      //   return this.options.groupOrderMaxQuantity;
      // }
      if(this.selectExplainer){
        maxQuantity = this.options.groupExplainMaxQuantity;
      }
      return maxQuantity;
    },
    groupOrderMinQuantity() {
      if (
        this.selectExplainer &&
        this.options.groupExplainMinQuantity > 0 &&
        this.options.groupExplainMinQuantity <= this.groupOrderMaxQuantity
      ) {
        return this.options.groupExplainMinQuantity;
      }
      return 0;
    },
    showArea() {
      return this.areas.length > 0 && this.areas[0].children.length > 0;
    },
    maximumParkingSpacesForTeamBooking() {
      var spacingNum = this.busSpacingNum + this.carSpacingNum;
      var maximum = 10;
      // if (this.options.maximumParkingSpacesForTeamBooking > 0 && this.options.maximumParkingSpacesForTeamBooking <= 10) {
      //   maximum = this.options.maximumParkingSpacesForTeamBooking;
      // }
      return maximum > spacingNum ? spacingNum : maximum;
    },
    minDate() {
      let date = this.options.dates.filter((d) => !d.disable)[0];
      if (date) {
        return new Date(date.date);
      }
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },
    maxDate() {
      const date = moment().add(this.options.maxBookDays, "days").toDate();
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    // ...mapState({
    //   member: (state) => state.memberModule.member,
    // }),
  },
  methods: {
    onAdultQuantityChange(num) {
      if (this.changing) return;
      this.changing = true;
      
      let next = num;
      let errorMsg="";
      if (this.groupOrderMinQuantity> 0 && num < this.groupOrderMinQuantity) {
        if(this.selectExplainer){
          errorMsg += "公益讲解预约最少" + this.groupOrderMinQuantity + "人";
        }
        else{
          errorMsg += "每单最少" + this.groupOrderMinQuantity + "人";
        }
        next = this.groupOrderMinQuantity;
      }
      else if(this.groupOrderMaxQuantity > 0 && num > this.groupOrderMaxQuantity) {
        if(this.selectExplainer){
          errorMsg += "公益讲解预约最多" + this.groupOrderMaxQuantity + "人";
        }
        else{
          errorMsg += "每单最多" + this.groupOrderMaxQuantity + "人";
        }
        next = this.groupOrderMaxQuantity;
      }
      else{
        next = num;
      }

      if (errorMsg) {
        this.$toast(errorMsg);
      }
      this.personNum = next;

      this.changing = false;
    },
    onAdultQuantityBlur(e) {
      if (this.fixing) return;
      this.fixing = true;

      const inputEl = e.target;
      const raw = inputEl.value;
      const num = parseInt(raw, 10);

      let next = this.personNum;
      if (!isNaN(num)) {        
        if( this.groupOrderMinQuantity > 0 && num < this.groupOrderMinQuantity){
          next = this.groupOrderMinQuantity;
        }
        else if(this.groupOrderMaxQuantity > 0 && num > this.groupOrderMaxQuantity){
          next = this.groupOrderMaxQuantity;
        }  
        else{
          next = num;
        }     
      }

      //1. 先改数据
      this.personNum = next;

      //2. 再强制覆盖 DOM（打断 stepper 的内部状态）
      this.$nextTick(() => {
        if (inputEl) {
          inputEl.value = this.personNum;
        }
        this.fixing = false;
      });
    },
    changCiText(changci) {
      let text = changci.disabled ? (changci.quantity > 0 ? "已过期" : "已约满") : "可预约" ;
      return text;
    },
    confirmBtnFn(e){
        this.licensePlateNumbers[e.idx].licensePlateNumber=e.plateNumber;
    },    
    cphClick(i) {
      this.clickIndex=i;
      var tempcph = [];
      var PlateNumber= this.licensePlateNumbers[i].licensePlateNumber.split('');
      for(var j=0 ;j<PlateNumber.length;j++)
      {
        if(j<8)
        {
          tempcph.push(PlateNumber[j]);
        }
      }
      this.cph=tempcph;
      this.showkeyboard=true;
    },
    validParkingAreaSurplus(quantity) {
      let errorMsg = "";
      if (this.busSpacingNum + this.carSpacingNum < quantity) {
        errorMsg += "停车位不足。";
      }
      return errorMsg;
    },
    onLicensePlateNumberQuantity(event) {
      let errorMsg = "";
      let minNum = 0;
      if (!errorMsg) {
        if (event > this.maximumParkingSpacesForTeamBooking) {
          minNum = this.maximumParkingSpacesForTeamBooking;
        } else {
          minNum = event;
        }
        errorMsg += this.validParkingAreaSurplus(minNum);
      }
      if (errorMsg) {
        this.$toast(errorMsg);
      } else if (minNum <= 0) {
        this.orderInput.needPackingLot = false;
      } else {
        this.licensePlateNumberQuantity = minNum;
      }
      //this.licensePlateNumberQuantity = event;
    },
    onLicensePlateNumberInput(val) {
      this.orderInput.licensePlateNumber = val
        .toUpperCase()
        .replace(/\s*/g, "");
    },
    beforeRead(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png"
      ) {
        this.$toast("请上传 jpg/jpeg/png 格式图片");
        return false;
      }
      return true;
    },
    async afterRead() {
      //console.log(JSON.stringify(this.fileList));
    },
    onShowCarType(index) {
      this.showCarTypeIndex = index;
      this.showCarType = true;
    },
    onCarTypeSelecter(item) {
      if (item.num <= 0) {
        this.$toast("车位已满");
        return;
      }
      this.licensePlateNumbers[this.showCarTypeIndex].carTypeId = item.value;
      this.licensePlateNumbers[this.showCarTypeIndex].carTypeName = item.name;
      this.showCarType = false;
    },
    onSelectExplainerTimePoint(child, children) {
      if (child.disabled) {
        let text = this.changCiText(child);
        this.$toast(`${text}，请选其他场次`);
      } else {
        if(!child.selected){          
          children.map((a) => {
            a.selected = false;
          });
          child.selected = true;
          this.orderInput.arrivalTime = "";
          this.minValue = child.text.substr(0,5);
          this.maxValue = child.text.substr(6,5);
          this.minHour = Number(child.text.substr(0,2));
          this.maxHour = Number(child.text.substr(6,2));
        } else {
          children.map((a) => {
            a.selected = false;
          });
          this.minValue = "";
          this.maxValue = "";
          this.minHour = defaultMinHour;
          this.maxHour = 18;
        }        
      }
      
      let errorMsg = "";
      if ( this.groupOrderMinQuantity > 0 && this.personNum < this.groupOrderMinQuantity) {
        if(this.selectExplainer){
          errorMsg += "公益讲解预约最少" + this.groupOrderMinQuantity + "人";
        }
        else{
          errorMsg += "每单最少" + this.groupOrderMinQuantity + "人";
        }
        this.$toast(errorMsg);
        this.personNum = this.groupOrderMinQuantity;
      }
      else if (this.personNum > this.groupOrderMaxQuantity) {
        if(this.selectExplainer){
          errorMsg += "公益讲解预约最多" + this.groupOrderMaxQuantity + "人";
        }
        else{
          errorMsg += "每单最多" + this.groupOrderMaxQuantity + "人";
        }
        this.$toast(errorMsg);
        this.personNum = this.groupOrderMaxQuantity;
      }
    },
    onSelecterseert(item) {
      this.orderInput.keYuanTypeId = item.value;
      this.orderInput.keYuanTypeName = item.name;
      this.keydfseet = false;
    },
    dateChanged(index) {
      let date = this.options.dates[index];
      if (date.disable) {
        return;
      }
      this.orderInput.travelDate = date.date;

      // this.$emit("input", this.orderInput.travelDate);
    },
    selectMoreDate() {
      this.showDateTimePicker = true;
    },
    confirmMoreDate(value) {
      this.showDateTimePicker = false;

      value = moment(value);
      this.orderInput.travelDate = value.format("YYYY-MM-DD");
      // this.$emit("input", this.orderInput.travelDate);
      if (
        this.options.dates.filter((d) => d.date == this.orderInput.travelDate)
          .length <= 0
      ) {
        this.options.dates[this.options.dates.length - 1] = {
          date: this.orderInput.travelDate,
          text: value.format("ddd") + value.format("MM-DD"),
          disable: false,
        };
      }
    },
    setTravelDate() {
      if (this.orderInput.travelDate == "") {
        this.orderInput.travelDate = this.options.dates.filter(
          (d) => !d.disable
        )[0].date;
      } else {
        var temp = this.orderInput.travelDate;
        if (this.options.dates.filter((d) => d.date == temp).length > 0) {
          this.orderInput.travelDate = this.options.dates.filter(
            (d) => d.date == temp
          )[0].date;
        } else {
          var value = moment(temp);
          this.options.dates[this.options.dates.length - 1] = {
            date: temp,
            text: value.format("MM-DD") + value.format("ddd"),
            disable: false,
          };
          this.orderInput.travelDate = this.options.dates[
            this.options.dates.length - 1
          ].date;
        }
      }
    },
    groundChange(event) {
      if (this.wxLastBookTime) return;
      this.orderInput.groundId = event.value;
      // this.orderInput.needExplain = false;
      this.orderInput.needPackingLot = false;
      this.orderInput.carTypeId = "";
      this.orderInput.licensePlateNumber = "";
      this.carTypes = [];
    },
    changCiChange(event) {
      this.orderInput.changCiId = event.value;
      //停车场
      this.packingLotId = event.packingLotId;
      this.carSpacingNum = event.carSpacingNum;
      this.busSpacingNum = event.busSpacingNum;
      this.carTypeName = "";
      this.orderInput.carTypeId = "";
      this.orderInput.licensePlateNumber = "";
      if (this.packingLotId) {
        if (this.carSpacingNum > 0) {
          this.carTypes.push({
            value: 1,
            name: "小型车",
            num: this.carSpacingNum,
          });
        }
        if (this.busSpacingNum > 0) {
          this.carTypes.push({
            value: 2,
            name: "大客车",
            num: this.busSpacingNum,
          });
        }
        // this.carTypes = [
        //   { value: 1, name: "小型车 (剩余车位数:"+ this.carSpacingNum+")", num:this.carSpacingNum },
        //   { value: 2, name: "大客车 (剩余车位数:"+ this.busSpacingNum+")", num:this.busSpacingNum },
        // ];
      }
    },
    setDefaultTicketTypeId(grounds, ticketTypeIds) {
      for (var i = 0; i < ticketTypeIds.length; i++) {
        for (var j = 0; j < grounds.length; j++) {
          if (!grounds[j].disabled && grounds[j].value == ticketTypeIds[i]) {
            this.orderInput.groundId = ticketTypeIds[i];
            this.grounds = [
              {
                text: "区域",
                children: [grounds[j]],
              },
            ];
            return;
          }
        }
      }
    },
    async getGrounds() {
      this.wxLastBookTime = "";
      const grounds = await scenicService.getGroundDtosAsync({
        travelDate: this.orderInput.travelDate,
      });

      this.orderInput.groundId = "";

      //var ticketTypeIds = this.$route.query.ticketTypeIds;
      var ticketTypeIds = [];
      if (ticketTypeIds && ticketTypeIds.length > 0) {
        this.setDefaultTicketTypeId(grounds, ticketTypeIds);
      } else {
        this.grounds = [
          {
            text: "区域",
            children: grounds,
          },
        ];
      }
    },
    async getChangCis() {
      if (!this.orderInput.groundId) {
        return;
      }

      if (dateHelper.validEqualDateNow(this.orderInput.travelDate)) {
        this.wxLastBookTime = await scenicService.validExceedWxLastBookTime();
        if (this.wxLastBookTime) {
          return;
        }
      }

      this.orderInput.changCiId = "";
      //场次
      const changCis = await scenicService.getGroundChangCiItemsAsync({
        groupFlag: true,
        travelDate: this.orderInput.travelDate,
        groundId: this.orderInput.groundId,
        behalfFlag: true,
      });
      if (!changCis && changCis.length == 0) {
        this.$toast("该区域未设置入馆时段，请选择其它参观日期");
        return;
      }

      this.changCis = [
        {
          text: "场次",
          children: changCis.map((c) => {
            return {
              value: c.changCiId,
              text: c.sTime + "-" + c.eTime,
              disabled: c.disabled,
              surplusNum:  c.surplusNum <= 0 ? "0" : c.surplusNum,
              packingLotId: c.packingLotId,
              carSpacingNum: c.carSpacingNum,
              busSpacingNum: c.busSpacingNum,
            };
          }),
        },
      ];
      if (this.changCis[0].children.length > 0) {
        this.changCiChange(this.changCis[0].children[0]);
      } else {
        this.$toast("该区域未设置入馆时段，请选择其它参观日期");
        return;
      }
      //讲解
      try {
        this.loadingExplainer = true;
        this.explainers = await explainerService.getSchedulingsForBehalfAsync({
          Date: this.orderInput.travelDate,
          TicketTypeId: this.orderInput.groundId,
        });
        if(this.explainers && this.explainers.length > 0){
          this.orderInput.needExplain = true; 
        } else {
          this.orderInput.needExplain = false; 
        }
      } finally {
        this.loadingExplainer = false;
      }
    },
    setRegions(keYuanTypeId) {
      this.regions = this.areaItems.filter((a) => a.value == keYuanTypeId);
    },
    async onSubmit() {
      if (!this.orderInput.groundId) {
        this.$toast("请选择区域");
        return;
      }

      if (!this.orderInput.changCiId) {
        this.$toast("该区域未设置入馆时段，请选择其它参观日期");
        return;
      }
      // if(this.orderInput.needExplain && !this.selectExplainer){
      //   this.$toast("请选择公益讲解场次");
      //   return false;
      // }
      if(this.selectExplainer && !this.orderInput.arrivalTime){
        this.$toast("请选择讲解时间");
        return false;
      }
      this.ageRanges[3].personNum = this.personNum;
      let selectedAgeRanges = this.ageRanges.filter((a) => a.personNum > 0);
      if (selectedAgeRanges.length <= 0) {
        this.$toast("请输入参观人数");
        return;
      }
      this.orderInput.personNum = selectedAgeRanges
        .map((a) => a.personNum)
        .reduce((f, s) => s + f);
      
      if (this.orderInput.needExplain && this.selectExplainer && this.options.groupExplainMinQuantity > 0 && this.orderInput.personNum < this.options.groupExplainMinQuantity) { 
        this.$toast(`公益讲解预约最少${this.options.groupExplainMinQuantity}人`);
        return false;
      }
      if (this.orderInput.needExplain && this.selectExplainer && this.options.groupExplainMaxQuantity > 0 && this.options.groupExplainMaxQuantity < this.orderInput.personNum) {
        this.$toast(`公益讲解预约最多${this.options.groupExplainMaxQuantity}人`);
        return false;
      }
      if (this.orderInput.personNum > this.groupOrderMaxQuantity) {
        this.$toast(`每单最多${this.groupOrderMaxQuantity}人`);
        return;
      }
      this.orderInput.ageRanges = selectedAgeRanges.map((a) => {
        return { ageRangeId: a.value, personNum: a.personNum };
      });

      if (!this.orderInput.areaId && this.regionId) {
        this.orderInput.areaId = this.regionId;
      }

      let validateRules = [
        // {
        //   value: this.orderInput.customerId,
        //   name: "单位名称",
        //   rules: [{ rule: "required" }]
        // },
        {
          value: this.orderInput.customerName,
          name: "单位名称",
          rules: [{ rule: "required" }],
        },
        // {
        //   value: this.orderInput.arrivalTime,
        //   name: "讲解时间",
        //   rules: [{ rule: "required" }],
        // },

        // {
        //   value: this.orderInput.keYuanTypeId,
        //   name: "客源类型",
        //   rules: [{ rule: "required" }],
        // },
        // {
        //   value: this.orderInput.areaId,
        //   name: "客源地",
        //   rules: [{ rule: "required" }],
        // },
        {
          value: this.orderInput.contactName,
          name: "姓名",
          rules: [{ rule: "required" }],
        },
        {
          value: this.orderInput.contactMobile,
          name: "手机号",
          rules: [{ rule: "required" }, { rule: "isMobile" }],
        },
      ];

      let result = validate(validateRules);
      if (!result.success) {
        this.$toast(result.message);
        return;
      }

      if (this.orderInput.needPackingLot) {
        for (let i = 0; i < this.licensePlateNumbers.length; i++) {
          this.licensePlateNumbers[
            i
          ].licensePlateNumber = this.licensePlateNumbers[i].licensePlateNumber
            .toUpperCase()
            .replace(/\s*/g, "");
          let result = validate([
            {
              value: this.licensePlateNumbers[i].carTypeId,
              name: "车辆类型" + (i + 1) + " ",
              rules: [{ rule: "required" }],
            },
          ]);
          if (!result.success) {
            this.$toast(result.message);
            return false;
          }
          result = validate([
            {
              value: this.licensePlateNumbers[i].licensePlateNumber,
              name: "车牌号码" + (i + 1) + " ",
              rules: [{ rule: "required" }, { rule: "isPlateNumber" }],
            },
          ]);
          if (!result.success) {
            this.$toast(result.message);
            return false;
          }
        }
        this.orderInput.plateNumbers = this.licensePlateNumbers;
      }

      this.orderInput.visitLetterPhotoArray = [];
      if (this.fileList.length > 0) {
        for (var i = 0; i < this.fileList.length; i++) {
          this.orderInput.visitLetterPhotoArray.push(this.fileList[i].content);
        }
      }

      this.orderInput.explainerTimeslotSchedulings = [];
      if (this.explainers.length > 0) {
        this.explainers.forEach((element) => {
          element.children.forEach((child) => {
            if (child.selected) {
              this.orderInput.explainerTimeslotSchedulings.push({
                groundID: element.value,
                timeslotId: child.value,
              });
            }
          });
        });
      }

      try {
        this.loading = true;
        // let response = await orderService.createGroupOrderAsync(
        //   this.orderInput
        // );
        let response = await orderService.deliverOrdersOnBehalfAsync(
          this.orderInput
        );
        if (response.success) {
          this.$router.replace({
            name: "orderinfo",
            params: {
              listNo: response.result,
              showNavbar: true,
            },
          });
        }
      } catch (err) {
        return;
      } finally {
        this.loading = false;
      }
    },
    initTime() {
      let now = moment();
      this.minHour = now.hour() > this.maxHour ? this.maxHour : now.hour();
      this.orderInput.arrivalTime = ""; //this.minHour+":"+now.format("mm");
    },
    onQuerySearchFocus() {
      let top = 0;
      let element = document.querySelectorAll(".querySearch")[0];
      while (element) {
        top += element.offsetTop;
        element = element.offsetParent;
      }
      window.scrollTo(0, top - 50);
    },

    async querySearch(queryString, cb) {
      const keyword = queryString.trim();
      if (this.orderInput.customerName != keyword) {
        this.orderInput.customerName = keyword;
        this.orderInput.customerId = "";
        this.regionId = "";
        this.orderInput.areaId = "";
      }

      if (keyword.length < 2) {
        cb([]);
        return;
      }

      try {
        const customerItems = await customerService.getCustomerComboboxItemsAsync(keyword);
        this.setCustomerItems(customerItems);
        cb(this.restaurants);
      } catch (err) {
        cb([]);
      }
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
        );
      };
    },
    handleSelect(item) {
      this.orderInput.customerId = item.id;
      this.orderInput.customerName = item.value;
      this.regionId = "";
      this.regions[0].children.forEach((region) => {
        if (this.regionId == "") {
          region.children.forEach((child) => {
            if (this.regionId == "" && child.value == item.registAreaId) {
              if (region.value == "") {
                this.areas = [
                  {
                    text: "",
                    children: [],
                  },
                ];
              } else {
                this.regionId = region.value;
              }
            }
          });
        }
      });
      this.orderInput.areaId = item.registAreaId;
    },
    setCustomerItems(customerItems) {
      customerItems = customerItems || [];
      this.customers = [
        {
          text: "单位名称",
          children: customerItems.map((c) => {
            return {
              text: c.displayText,
              value: c.value,
              disabled: c.disabled,
              registAreaTypeId: c.registAreaTypeId,
              registAreaId: c.registAreaId,
            };
          }),
        },
      ];
      this.restaurants = customerItems.map((c) => {
        return {
          value: c.displayText,
          id: c.value,
          registAreaTypeId: c.registAreaTypeId,
          registAreaId: c.registAreaId,
        };
      });
    },
  },
  watch: {
    licensePlateNumberQuantity: function (newVal, oldVal) {
      try {
        this.loading = true;
        let diff = newVal - oldVal;
        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            let licensePlateNumber = new LicensePlateNumber();
            this.licensePlateNumbers.push(licensePlateNumber);
          }
        } else {
          if (this.licensePlateNumbers.length + diff > 0) {
            this.licensePlateNumbers.length += diff;
          } else {
            this.licensePlateNumbers.length = 0;
          }
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.travelDate": async function (newVal, oldVal) {
      try {
        this.loading = true;
        this.orderInput.groundId = "";
        this.grounds = [];
        this.changCis = [];
        this.explainers = [];
        this.orderInput.needPackingLot = false;
        this.orderInput.carTypeId = "";
        this.packingLotId = "";
        this.orderInput.licensePlateNumber = "";
        this.carTypes = [];
        // this.orderInput.needExplain=false;
        if (this.orderInput.travelDate == moment().format("YYYY-MM-DD")) {
          this.initTime();
        } else {
          this.minHour = defaultMinHour;
          this.orderInput.arrivalTime = defaultArrivalTime;
        }
        if (oldVal) {
          await this.getGrounds();
          await this.getChangCis();
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.groundId": async function (newVal) {
      try {
        this.loading = true;
        this.orderInput.changCiId = "";
        this.changCis = [];
        this.explainers = [];
        if (newVal) {
          await this.getChangCis();
        }
      } finally {
        this.loading = false;
      }
    },
    "orderInput.needPackingLot": async function (val) {
      try {
        this.loading = true;
        if (!val) {
          this.orderInput.carTypeId = "";
          this.carTypeName = "";
          this.orderInput.licensePlateNumber = "";
        } else {
          if (!this.orderInput.groundId) {
            this.orderInput.needPackingLot = false;
            this.orderInput.carTypeId = "";
            this.carTypeName = "";
            this.$toast("请选择区域");
            return;
          }
          if (!this.packingLotId) {
            this.orderInput.needPackingLot = false;
            this.orderInput.carTypeId = "";
            this.carTypeName = "";
            this.$toast("该区域没有停车场");
            return;
          }
          if (this.carTypes.length > 0) {
            if (this.carTypes[0].num <= 0) {
              this.orderInput.needPackingLot = false;
              this.orderInput.carTypeId = "";
              this.carTypeName = "";
              this.$toast("停车位不足");
              return;
            }
            this.orderInput.carTypeId = this.carTypes[0].value;
            this.carTypeName = this.carTypes[0].name;
          }
        }
      } finally {
        this.loading = false;
      }
    },
    // "orderInput.needExplain": async function (val) {
    //   try {
    //     this.loading = true;
    //     if (!val) {
    //       this.orderInput.arrivalTime="";
    //       if (this.explainers.length > 0) {
    //         this.explainers.forEach((element) => {
    //           element.children.map((a) => {
    //             a.selected = false;
    //           });
    //         });
    //       }
    //     } else {
    //       if (!this.orderInput.groundId) {
    //         this.orderInput.needExplain = false;
    //         this.$toast("请选择区域");
    //         return;
    //       }
    //       if (!this.orderInput.changCiId) {
    //         this.orderInput.needExplain = false;
    //         this.$toast("该区域未设置入馆时段，请选择其它参观日期");
    //         return;
    //       }
    //       if (this.explainers.length == 0) {
    //         this.orderInput.needExplain = false;
    //         // this.$toast("须提前"+this.options.groupExplainAdvanceDays+"天预约");
    //         this.$toast("暂无公益讲解场次");
    //         return;
    //       }
    //       if (this.explainers.filter((d) => !d.disabled).length == 0) {
    //         this.orderInput.needExplain = false;
    //         this.$toast("暂无公益讲解场次");
    //         return;
    //       }
    //     }
    //     // this.options = await orderService.getOrderOptionsForBehalfAsync(true, val);
    //     // this.setTravelDate();
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    // "orderInput.keYuanTypeId": function (val) {
    //   try {
    //     this.loading = true;
    //     this.regionId = "";
    //     if (val == "") {
    //       this.regions = [
    //         {
    //           text: "",
    //           children: [],
    //         },
    //       ];
    //     } else {
    //       this.setRegions(val);
    //     }
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    regionId: function (val, oldVal) {
      try {
        if (oldVal) {
          this.orderInput.areaId = "";
        }
        this.loading = true;
        if (val == "") {
          this.areas = [
            {
              text: "",
              children: [],
            },
          ];
        } else {
          this.areas = this.regions[0].children.filter((r) => r.value == val);
        }
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    this.initTime();

    this.options = await orderService.getOrderOptionsForBehalfAsync(
      true,
      false
    );
    this.setTravelDate();
    await this.getGrounds();

    await this.getChangCis();

    this.setCustomerItems([]);

    commonService.getAgeRangeComboboxItemsAsync().then((items) => {
      this.ageRanges = items.map((item) => {
        return {
          value: item.value,
          displayText: item.displayText,
          personNum: 0,
        };
      });
    });

    commonService.getTouristOriginTreeAsync().then((treeNode) => {
      let keYuanTypeItems = treeNode.nodes.map((item) => {
        return {
          value: item.value,
          text: item.displayText,
          disabled: item.disabled,
        };
      });
     
      this.keYuanTypes = [
        {
          text: "客源类型",
          children: keYuanTypeItems,
        },
      ];

      this.areaItems = treeNode.nodes.map((keYuan) => {
        return {
          value: keYuan.value,
          children: keYuan.nodes.map((region) => {
            return {
              text: region.displayText,
              value: region.value,
              disabled: region.disabled,
              children: region.nodes.map((area) => {
                return {
                  text: area.displayText,
                  value: area.value,
                  disabled: area.disabled,
                };
              }),
            };
          }),
        };
      });

      this.setRegions(keYuanTypeItems[0].value);
    });
  },
  mounted() {},
};
</script>

<style lang="scss">
.van-grid-item__content {
  background-color: transparent;
}
.group-order {
  .van-hairline--top-bottom::after {
    border-width: 0;
  }

  .van-cell__value {
    text-align: left;
  }

  &-person {
    .van-cell {
      padding: 3px 15px;
    }

    .van-cell:not(:last-child)::after {
      border: none;
    }
  }

  &-tips {
    padding: 5px 10px;
    margin-top: 7px;
    margin-bottom: 10px;
    font-size: 12px;
    background-color: rgb(245, 249, 248);

    span {
      padding-left: 5px;
    }
  }

  &-switch {
    vertical-align: middle;
  }
}

.inline-cell {
  .van-cell {
    padding: 0;
  }

  .van-hairline--bottom::after {
    border-bottom-width: 0;
  }

  .van-cell:not(:last-child)::after {
    border-bottom-width: 0;
  }
}

.explain {
  display: flex;
  align-items: center;

  &-tips {
    margin-left: 10px;
    font-size: 12px;
    background-color: rgb(245, 249, 248);

    span {
      padding-left: 5px;
    }
  }
}
</style>

<style scoped lang="scss">
.inline-input {
  /deep/ .el-input__inner {
    border: none;
    width: calc(100vw - 120px);
  }
  ::-webkit-input-placeholder {
    /* Chrome */
    color: #969799;
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: #969799;
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: #969799;
    opacity: 1;
  }
  :-moz-placeholder {
    /* Firefox 4 - 18 */
    color: #969799;
    opacity: 1;
  }
}
</style>


<style scoped lang="scss">
.popTop {
  position: relative;

  .popTitle {
    font-size: 14px;
    padding: 10px;
  }

  .close {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.popContent {
  box-sizing: border-box;
  padding: 20px;
  min-height: 125px;
  display: flex;
  justify-content: center;
}

.popFooter {
  display: flex;

  .btn {
    font-size: 14px;
    color: #222222;
    flex: 1;
    padding: 14px 0;
    background: #efefef;
    font-weight: bold;
  }

  .cancelBtn {
    flex: 1;
  }

  .confirmBtn {
    flex: 1;
    background: #ff2343;
    color: #fff;
  }
}

.license-plate {
  padding: 10px;
  .cph-wrap {
    display: flex;
    justify-content: flex-start;
    font-size: 18px;
    line-height: 40px;
    min-height: 40px;

    .active {
      width: 29.5px;
      height: 40px;
      background-color: #cfd3dd;
    }
  }

  .cph-wrap-shadow {
    background-color: #fff;
    z-index: 0;
    margin: 30px 10px;
  }

  .cph-wrap-shadow span {
    font-size: 18px;
  }

  .cph-wrap span {
    position: relative;
    text-align: center;
    width: 29.5px;
    height: 40px;
    border-radius: 2px;
    border: 1px solid #e1e1e1;
    margin-right: 7px;
    background-color: #fff;
    color: #222;
    z-index: 99;
  }

  .cph-wrap span:first-of-type {
    margin-left: 0;
  }

  .cph-wrap span:nth-of-type(8) {
    margin-right: 0;
  }

  .cph-wrap span:last-child::before {
    content: none;
  }

  .keyboard-wrap {
    z-index: 1000;
    background: #cfd3dd;
    padding: 0 2px 0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .keyboardHeader {
      display: flex;
      background-color: #fff;
      margin: 1px -2px 10px -2px;
      line-height: 40px;
      justify-content: space-between;
      align-items: center;
      .specials {
        font-size: 18px;
        margin-left: 12px;
        color: #222;
      }

      .kspecials {
        color: #ccc;
      }

      .close {
        padding-right: 10px;
        display: flex;
        justify-content: flex-end;

        span {
          color: #999;
          text-decoration: none;
          display: block;
          width: 40px;
          height: 40px;
          text-align: center;
          font-size: 16px;
        }
      }
    }
  }

  .keyboard {
    display: flex;
    justify-content: center;
    flex-flow: row wrap;
    position: relative;

    span {
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 1px 2px #666;
      width: calc(10% - 4px);
      text-align: center;
      height: 46px;
      line-height: 46px;
      margin: 0 2px 8px;
      font-size: 16px;
    }

    .k-del {
      width: 40px;
      position: absolute;
      right: 2px;
      display: block;
    }

    .k-del img {
      display: block;
      margin: 9px auto;
    }

    .k-done {
      width: 60px;
      position: absolute;
      right: 2px;
      display: block;
      background-color: #0084ff;
      color: #fff;
      font-weight: bold;
    }

    .k-done2 {
      left: 2px;
      width: 40px;
    }
  }

  .keyboard > div {
    display: flex;
  }

  .slide-enter-active,
  .slide-leave-active {
    transition: all 0.3s;
    opacity: 1;
    transform: translateY(0);
  }

  .slide-enter,
  .slide-leave-to {
    opacity: 0;
    transform: translateY(400px);
  }
}

.cph-box {
  position: relative;
  margin: 65px auto;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;

  .numtitle {
    font-size: 18px;
    color: #222222;
    text-align: center;
    line-height: 50px;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    font-weight: normal;
  }
}

span.hide {
  opacity: 0;
}

.active_key {
  background-color: #000;
  opacity: 0.2;
}
</style>
